/* eslint-disable no-unused-vars */
import { Button, Input, InputNumber, Modal, Select, Spin, message } from 'antd'
import {
  operationSolarInvPerormanceWithInvEvents,
  solarPerformanceUpdate,
} from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
import { monthsMap } from 'core'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { Label } from 'core/screen-util'
import React, { useContext, useMemo, useState } from 'react'
import { getPermitActions } from '../core/selectors'
import { connect } from 'react-redux'
import {
  SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
  SOLAR_ADMIN_POWER_DATA,
} from '../core/EventActions'
import { hasAccesPermits } from 'core/utils'
import { operationSolarStorageInvPerormanceWithInvEvents } from './solarapi'

const SolarStorageInverterPerformanceDialog = ({
  data,
  targetInfo,
  visible,
  onHide = _ => _,
  onRetrieve,
  isNew = false,
  availableStatus = [],
  setTmpError,
  inverterIdBYPlant,
  actionPermits,
  isStorageDialog = false,
}) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [insertData, setInsertData] = useState(data)

  const hasSolarPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: actionPermits,
        eventActions: [
          SOLAR_ADMIN_POWER_DATA,
          SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const onSave = _ => {
    const api = operationSolarStorageInvPerormanceWithInvEvents

    api(targetInfo)([insertData]).fork(setError, data => {
      if (isErrorContains(data)) {
        setTmpError(data)
      } else {
        message.info('Data saved.')
        setTmpError(data, _ => {
          onHide()
          onRetrieve()
        })
      }
    })
  }

  return (
    <Modal
      onCancel={onHide}
      visible={visible}
      footer={
        <div>
          <div>
            {hasSolarPowerDataWritePermission && (
              <Button type="primary" onClick={onSave}>
                Save{' '}
              </Button>
            )}
            <Button onClick={onHide}>Cancel</Button>
          </div>
        </div>
      }
      centered
      height={400}
      width={1000}
      title={<div>Inverter Performance Data : {insertData.inverterId}</div>}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '150px  150px 150px 100px 100px 100px',
            gap: 5,
            width: 1000,
          }}
        >
          <Label>Inverter ID :</Label>
          {!isNew && (
            <Input
              style={{}}
              value={insertData.inverterId}
              onChange={e =>
                setInsertData({ ...insertData, inverterId: e.target.value })
              }
              disabled
            />
          )}
          {!isNew && [
            <Label key="lab">Storage Group ID :</Label>,
            <Input
              key="txt"
              style={{}}
              value={insertData.storageGroupId}
              onChange={e =>
                setInsertData({
                  ...insertData,
                  storageGroupId: e.target.value,
                })
              }
              disabled
            />,
          ]}

          {isNew && (
            <Select
              value={insertData.inverterId}
              onChange={inverterId =>
                setInsertData({ ...insertData, inverterId })
              }
            >
              {inverterIdBYPlant.map(({ inverterId }) => (
                <Select.Option key={inverterId} value={inverterId}>
                  {inverterId}
                </Select.Option>
              ))}
            </Select>
          )}
          <div style={{ gridColumnEnd: 'span 2' }} />
          <Label>Inverter Availability :</Label>
          <Select
            value={insertData.inverterAvailability}
            onChange={inverterAvailability =>
              setInsertData({ ...insertData, inverterAvailability })
            }
          >
            {availableStatus.map(d => (
              <Select.Option
                key={d.availabilityStatusCode}
                value={d.availabilityStatusCode}
              >
                {d.availabilityStatusName}
              </Select.Option>
            ))}
          </Select>
          <div style={{ gridColumnEnd: 'span 4' }} />
          <Label>Charge (MWh) :</Label>
          <InputNumber
            value={insertData.chargeMWH}
            onChange={chargeMWH => setInsertData({ ...insertData, chargeMWH })}
          />
          <Label>Charge (HRS) :</Label>
          <InputNumber
            value={insertData.chargeHRS}
            onChange={chargeHRS => setInsertData({ ...insertData, chargeHRS })}
          />
          <Label>FO (HRS) :</Label>
          <InputNumber
            value={insertData.foHRS}
            onChange={foHRS => setInsertData({ ...insertData, foHRS })}
          />
          <Label>Discharge (MWh) :</Label>
          <InputNumber
            value={insertData.dischargeMWH}
            onChange={dischargeMWH =>
              setInsertData({ ...insertData, dischargeMWH })
            }
          />

          <Label>Discharge (HRS) :</Label>
          <InputNumber
            value={insertData.dischargeHRS}
            onChange={dischargeHRS =>
              setInsertData({ ...insertData, dischargeHRS })
            }
          />

          <Label>MO (HRS) :</Label>
          <InputNumber
            value={insertData.moHRS}
            onChange={moHRS => setInsertData({ ...insertData, moHRS })}
          />
          <div style={{ gridColumnEnd: 'span 4' }} />
          <Label>PO (HRS) :</Label>
          <InputNumber
            value={insertData.poHRS}
            onChange={poHRS => setInsertData({ ...insertData, poHRS })}
          />
        </div>
      </Spin>
    </Modal>
  )
}
const mapStateToProps = state => ({ actionPermits: getPermitActions(state) })

export default connect(mapStateToProps)(SolarStorageInverterPerformanceDialog)
